import {
  AfterViewInit,
  Component, EventEmitter, forwardRef, HostListener,
  inject, Input, OnDestroy,
  OnInit, Output,
  ViewChild
} from '@angular/core';
import { CommonModule } from "@angular/common";
import { FormsModule } from '@angular/forms';

import { TabsModule } from 'ngx-bootstrap/tabs'
import {
  compact,
  extend,
  forEach,
  get,
  includes,
  isEqual,
  set,
  some,
  endsWith,
  trim,
  every,
  isEmpty,
  map,
  filter,
  union,
  update,
  split,
  startsWith,
  startCase,
  toLower,
  isFunction
} from 'lodash-es';

import { AppManagerService } from "./runtime/services/app.manager.service";
import { isDefined } from "@wm/core";

import {MarkupManagerService, StudioUtils, widgetOptions, WIDGET_CONSTANTS, getCanvasElement, VersionManagerPipe} from "@wms/core";
import {
  BaseComponent,
  WmsDialogComponent,
  WmsListWidgetConfigComponent,
  WmsTableWidgetConfigComponent,
  WmsCardWidgetConfigComponent,
  WmsFormWidgetConfigComponent,
  WmsLiveformWidgetConfigComponent,
  WmsAddNewPageComponent,
  WmsCarouselWidgetConfigComponent, WmsLiveFilterWidgetConfigComponent
} from '@wms/components';
import {PageWorkspaceComponent, PageWsService} from "@wms/workspace";

import { WmsCanvasDomComponent, widgetInfo, DroppedWidgetInfo } from "./canvas/wm-canvas-dom.component";
import { PropertiesPanelComponent, PropertiesTemplateComponent } from '@wms/properties-panel';
import { propFactory as PropertiesFactory } from "@wm/components-base";
import {DialogService, PageService, ProjectService} from '@wms/services';

import { Parent } from "@wms/app/parent";
import { WidgetPropertiesProvider } from "@wms/app/design-container/services/widget-utils.service";
import { WmsIconSelectorComponent } from "@wms/app/components/wms-icon-selector/wms-icon-selector.component";
import { CanvasDomService } from "./canvas/canvasDomService";
import { TypeFactoryService } from "@wms/services";
import { AppRef } from "@wms/app/design-container/runtime/services/app.service";
import { PrefabManager } from "@wms/page-workspace";
import { LiveWidgetSettingsService } from '../services/liveWidgetsSettings/live-widget-settings.service';
import {runtimeEventManager} from "@wm/core";
import { TableDesignerComponent, FormDesignerComponent, ChartDesignerComponent, WidgetStylingService } from '@wms/design-container';
import { WmsWidgetXPathComponent, WmsWidgetContextMenuComponent } from '@wms/design-container';
import { WmsViewSelectorComponent } from './canvas/wms-view-selector/wms-view-selector.component';
import { WidgetDesignerComponent } from "@wms/app/design-container/widget-designer.component";
import { WmsChangeLayoutComponent } from "@wms/components";
import {UploadResourcesDialogComponent} from "@wms/app/upload-resources-dialog/upload-resources-dialog.component";
import {AboutDialogComponent} from "@wms/app/about-dialog/about-dialog.component";
import {getByContext, isSpinnerType, VARIABLE_CONSTANTS} from "@wms/variables";
import { LiveFilterDesignerComponent } from "@wms/app/design-container/live-filter-designer/live-filter-designer.component";
import {ImportIconsComponent} from "@wms/app/import-icons/import-icons.component";
import { WmsCanvasSandboxWrapper } from "./canvas/wms-canvas-sandbox-wrapper/wms-canvas-sandbox-wrapper.component";
import { AgenticChatComponent } from "@wms/agentic-chat";
import {WmsFeatureDirective} from "@wms/directives";
import {BsDropdownDirective, BsDropdownModule} from "ngx-bootstrap/dropdown";


let CLASS = {
  'ACTIVE_WIDGET': 'canvas-active-widget',
  'DROP_TARGET_PARENT': 'widget-drop-target'
};

interface Property {
  disabled?: boolean;
  show?: boolean;
  type: string;
  value: any;
  pattern?: string;
}

@Component({
  standalone: true,
  selector: 'wms-design-container',
  templateUrl: './design-container.component.html',
  styleUrls: ['./design-container.component.css'],
  imports: [
    CommonModule,
    TabsModule,
    FormsModule,
    PropertiesPanelComponent,
    PropertiesTemplateComponent,
    TabsModule,
    WmsCanvasDomComponent,
    WmsDialogComponent,
    WmsListWidgetConfigComponent,
    WmsIconSelectorComponent,
    WmsTableWidgetConfigComponent,
    WmsFormWidgetConfigComponent,
    WmsLiveformWidgetConfigComponent,
    WmsCardWidgetConfigComponent,
    WmsAddNewPageComponent,
    TableDesignerComponent,
    WmsViewSelectorComponent,
    FormDesignerComponent,
    WmsChangeLayoutComponent,
    WmsWidgetXPathComponent,
    WmsWidgetContextMenuComponent,
    ChartDesignerComponent,
    WmsLiveFilterWidgetConfigComponent,
    WmsCarouselWidgetConfigComponent,
    AboutDialogComponent,
    UploadResourcesDialogComponent,
    LiveFilterDesignerComponent,
    ImportIconsComponent,
    WmsCanvasSandboxWrapper,
    AgenticChatComponent,
    WmsFeatureDirective,
    BsDropdownModule,
    VersionManagerPipe
  ],
  providers: [
    WidgetDesignerComponent,
    BsDropdownDirective,
    {
      provide: Parent,
      useExisting: forwardRef(() => DesignContainerComponent)
    }]
})
export class DesignContainerComponent extends BaseComponent implements AfterViewInit, OnDestroy {
  @ViewChild(WmsCanvasDomComponent) canvasDomComponent!: WmsCanvasDomComponent;
  @ViewChild('canvasEl', { static: false }) canvasEl: any;
  @ViewChild(PropertiesPanelComponent) propPanel!: PropertiesPanelComponent;
  @ViewChild('dropdownPageAction')dropdownPageAction:BsDropdownDirective
  CONSTANTS = {
    EXCLUDED_PAGES_BY_FEATURE: {
      DELETE: ['Main', 'Common', 'Login', 'footer', 'header', 'rightnav', 'leftnav', 'topnav'],
      RENAME: ['Main', 'Common', 'Login', 'footer', 'header', 'rightnav', 'leftnav', 'topnav']
    }
  }
  showConstructionLine: boolean = true;
  fitScreen: boolean = false;
  activeTab = 'DESIGN'
  activeWidget: any;
  public addWidgetInfo: widgetInfo = {};
  private dialogService: DialogService;
  protected activeMarkupEl: JQuery<HTMLElement> | undefined | null;
  private activeProperty = {};
  /*shadow properties are the intermediary properties between property panel properties and activeWidget properties.
         On widget selection active widget properties are copied into the  shadow properties*/
  private shadowProperties: { [key: string]: any } = {};
  private readonly appManager: AppManagerService;
  public pageWs: PageWorkspaceComponent;
  public $$canvas: JQuery<HTMLElement>;
  private $widget: any;
  private $focusNode: JQuery<HTMLElement> | undefined;
  private $toolbar: JQuery<HTMLElement> | undefined;
  private $sortHandle: JQuery<HTMLElement> | undefined;
  private lastPos: { [key: string]: number | undefined } = {
    pageX: undefined,
    pageY: undefined
  };
  private $dropPrediction: JQuery<HTMLElement> = $('.wm-drop-prediction');
  private WidgetProperties: any;
  private widgetStylingService: any;
  protected isMobileApplicationType: boolean;
  protected isNativeMobileApplicationType: boolean;
  private isTemplateBundleType: boolean;
  protected isPrism:boolean
  typeFactoryService: TypeFactoryService;

  liveWidgetSettingsService: LiveWidgetSettingsService;
  propPanelInfo: any;
  widgetConfigForDialog: any;
  pageService:PageService;
  useShadowDom:any;
  showAgenticChat: boolean = false;
  isHidden:boolean ;
  pageWSService:PageWsService;



  @Input() pageInfo: any;
  @Input() isPrefabTemplate: boolean;
  @Input() isApplicationType: boolean;

  constructor(private prefabManager: PrefabManager, private canvasDomService: CanvasDomService, private appRef: AppRef, private markupManager: MarkupManagerService) {
    super();
    this.pageWs = inject(PageWorkspaceComponent);
    this.WidgetProperties = inject(WidgetPropertiesProvider);
    this.widgetStylingService = inject(WidgetStylingService);
    this.appManager = inject(AppManagerService);
    this.dialogService = inject(DialogService);
    this.typeFactoryService = inject(TypeFactoryService);
    this.liveWidgetSettingsService = inject(LiveWidgetSettingsService);
    this.pageService = inject(PageService);
    this.pageWSService =inject(PageWsService);

    let projectService = inject(ProjectService);
    this.isMobileApplicationType = projectService.isMobileApplicationType();
    this.isNativeMobileApplicationType = projectService.isNativeMobileApplicationType();
    this.isTemplateBundleType = projectService.isTemplateBundleType();
    this.isPrism = projectService.isPrism();
    /* If project is of type prism and application type then it should be wrapped inside a shadow dom */
    this.useShadowDom = projectService.shouldUseShadowDom();

    StudioUtils.init();

    this.registerDestroyListener.add(this.appManager.subscribe('canvas-markup', (markup: any) => {
      this.markupManager.setMarkupRoot(markup);
    }));

    this.registerDestroyListener.add(this.appManager.subscribe('pageReady', (data: any) => {
      this.canvasDomComponent.setActiveWidget();
      this.registerEvents();
    }));
    this.registerDestroyListener.add(this.eventManager.widgetSelectionObservable().subscribe((data: any) => this.onWidgetSelection.bind(this, data?.disableCanvasDomServiceClick)()));
    this.registerDestroyListener.add(this.eventManager.resetActiveCanvasElObservable().subscribe(() => {
      this.activeWidget = null;
      // this.markupManager.resetIdMap();
    }));
    this.registerDestroyListener.add(runtimeEventManager.on('reset-active-canvas-el').subscribe(() => {
      this.activeWidget = null;
    }));
    this.registerDestroyListener.add(runtimeEventManager.on('update-view').subscribe((data) => {
      this.views = data.views;
      if (data.triggerClick) {
        setTimeout(() => {
          const activeView = $('.canvas-container').find('[id=' + this.activeWidget.name + ']');
          activeView && activeView[0]?.click();
        }, 50);
      }
    }));
    this.registerDestroyListener.add(this.eventManager.openDialogWithIDObservable().subscribe((data: any) => {
      this.openDialogWithId(data.dialogId, data.config);
    }));

    this.eventManager.setMarkupAttrObservable().subscribe((data: any) => {
      this.markupManager.setAttr(data.widgetId, data.attrs, data.childSelector);
      //Update the shadow properties along with the markup update
      if (get(this, 'activeWidget.widgetId') === data.widgetId) {
        forEach(data.attrs, (value, key) => {
          this.activeWidget[key] = value;
        });
      }
    })

    this.eventManager.setEventAttrObservable().subscribe((data: any) => {
      //Update the event model
      if (get(this, 'activeWidget.widgetId') === data.widgetId) {
        let __key: string;
        forEach(data.attrs, (value: string, key: string) => {
          __key = '__' + key;
          this.activeWidget[__key] = value;
        });
      }
    })

    this.registerDestroyListener.add(this.eventManager.setActivepropObservable().subscribe((data: string) => {
      this.setActiveProperty(data);
    }));

    this.registerDestroyListener.add(this.eventManager.closeDialogWithIdAsObservable().subscribe((data) => {
      this.closeDialogWithId(data);
    }));

    this.registerDestroyListener.add(runtimeEventManager.on('set-markup-attr').subscribe((data) => {
      this.eventManager.emitSetMarkupAttr('set-markup-attr', data.widgetId, {...data}, '');
    }))

    this.registerDestroyListener.add(runtimeEventManager.on('set-event-attr').subscribe((data)=>{
      this.eventManager.emitSetEventAttr('set-event-attr', data.widgetId, {...data}, '');
    }));

    this.registerDestroyListener.add(runtimeEventManager.on('widgetSelection').subscribe(() => {
      this.onWidgetSelection();
    }));
    this.registerDestroyListener.add(runtimeEventManager.on('updateShadowProperty').subscribe(() => this.setShadowProperties(this.activeWidget.widgetProps)));
    this.registerDestroyListener.add(runtimeEventManager.on('updatePropPanelOptions').subscribe((data) => this.updatePropertyPanelOptions(data)));
    this.registerDestroyListener.add(runtimeEventManager.on('wms:refresh-properties-panel').subscribe(() => {this.showHideSubGroups();}));

    this.eventManager.loadViewObservable().subscribe((data: any) => {
      this.loadView(data);
    });

    this.registerDestroyListener.add(this.eventManager.pageRenderedObservable().subscribe((response) => {
      this.appManager.notify('markup-loaded', '');
    }));
    window.addEventListener('closeChatWindow', this.hideAgenticChat.bind(this));
  }

  loadView(data: any) {
    const selectedView: any = data.selectedView;
    let obj: any = {
      'eventType': 'SELECT',
      'widgetId': undefined
    };
    if (!selectedView) {
      return;
    }
    let domElement = $(getCanvasElement());
    if (selectedView === '$PAGE$') {
      let parentElemSelector;
      if (!this.appRef.isPrefabType) {
        parentElemSelector = ".app-page";
      } else {
        parentElemSelector = ".app-prefab-container > .app-ng-transclude";
      }
      if($(domElement.find(parentElemSelector).children()).is(':hidden')) {
        $(domElement.find(parentElemSelector).children()).show();
      }
      let $dialog = $(domElement).find('[wmdialog], [wmalertdialog], [wmconfirmdialog], [wmiframedialog], [wmpagedialog], [wmlogindialog], [wmbottomsheet]');
      this.hideOnlyViewsOutsideOfMainContent($dialog);
      domElement.find(parentElemSelector + ' > main.app-content > .app-content-row > .app-page-content > div > .app-view').hide();
      obj.widgetId = domElement.find(parentElemSelector).attr('widgetid');
      this.eventManager.emitOnWidgetSelection(obj)
    } else if (selectedView === '$PARTIAL$') {
      domElement.find('[wmpartial]').find('.app-view').hide();
      obj.widgetId = domElement.find('[wmpartial]').attr('widgetid');
      domElement.find("[widgetid='" + obj.widgetId + "']").show();
      if (this.activeWidget?.widgetId !== obj.widgetId) {
        domElement.find("[widgetid='" + obj.widgetId + "']").children().show();
      }
      $(this.activeWidget.$element).siblings().show();
      this.eventManager.emitOnWidgetSelection(obj);
    } else {
      obj.widgetId = selectedView.widgetId;
      // hiding all the children
      let appViews = domElement.find("[widgetid='" + selectedView.parentWidgetId + "'] .app-view");
      this.hideOnlyViewsOutsideOfMainContent(appViews);
      //find the elements in structure directly under page
      this.hideOnlyViewsOutsideOfMainContent(domElement.find('.app-page').find('.app-view'));

      this.eventManager.emitOnWidgetSelection(obj);
      $(this.activeWidget.$element).siblings().hide();
      this.activeWidget.$element.show();
      this.activeWidget.$element.find('.app-view').show().css('z-index', 1014);
      let dialogEl = domElement.find("[widgetid='" + selectedView.widgetId + "']")[0];
      if (dialogEl) {
        let pageEl = domElement.find('[wmpage]')[0];
        // for full height navigation, make width 100% in dialog view
        if($(pageEl).hasClass('app-nav-full')) {
          (dialogEl as any).widget.$element.css('width', '100%')
        }
        set(dialogEl, 'widget.loadDialogContent', true);
      }

      //widgets like chart, google maps require redraw method to be executed.
      domElement.find("[widgetid='" + selectedView.widgetId + "'].app-view")
        .each(() => {
          // Utils.triggerFn(WM.element(this).isolateScope().redraw);
        });
    }
  }

  hideOnlyViewsOutsideOfMainContent(appViews: JQuery<HTMLElement>) {
    if (appViews.length) {
      forEach(appViews, (e) => {
        if (!e.closest('[data-role="page-content"]') || e.hasAttribute('wmbottomsheet')) {
          $(e).hide();
        }
      })
    }
  }

  ngAfterViewInit() {
    set(this.pageWs.componentRefProvider, 'prepareElements', this.canvasDomComponent.prepareElements.bind(this.canvasDomComponent));
    // @ts-ignore
    this.$$canvas = $(this.canvasEl.nativeElement) as JQuery<HTMLElement>;
    if(this.dropdownPageAction){
      this.dropdownPageAction.isOpen= false;
    }
    // this.canvasDomService.onInit(this);
  }

  openDialogWithId(id: string, config: any) {
    this.widgetConfigForDialog = config;
    this.dialogService.open(id);
  }

  closeDialogWithId(id: string, removeInstance?: boolean) {
    this.widgetConfigForDialog = undefined;
    this.eventManager.emitcanvasAddWidgetDragEndEvent();
    this.dialogService.close(id, removeInstance);
  }

  getActiveWidgetPropData(prop: string) {
    return get(this.activeWidget.widgetProps, prop);
  }

  registerEvents() {
    this.$$canvas?.on('mousedown selectstart', 'select', (e) => {

      if (!$(e.currentTarget).is('.app-tabs > .tabs-list')) {
        e.preventDefault();
        e.target.focus();
      }
    });
  }

  handleConfigDialogSubmit(data: { widgetDefs: { [key: string]: any }, widgetDetails: DroppedWidgetInfo }) {
    let widgetInfo: any = data.widgetDetails;

    widgetInfo.widgetDefaults = {
      contentTemplate: $(data.widgetDefs['template'])
    }
    this.canvasDomService.notifyAdd(widgetInfo);
  }

  setShadowPropertiesAfterInit() {
      if (this.activeWidget.initState || this.activeWidget.widgetType === 'wm-prefab' || this.activeWidget.widgetType === 'wm-custom-widget' ||  this.activeWidget.widgetType === 'wmx-component') {
        this.activeWidget.registerReadyStateListener(() => {
          this.setShadowProperties(this.activeWidget.widgetProps);
        });
      } else {
        this.setShadowProperties(this.activeWidget.widgetProps);
      }
  }

  onWidgetSelection(disableCanvasDomServiceClick: boolean = false) {
    let canvasEl = this.markupManager.getActiveCanvasEl();
    let canvasElScope,
      widgetProps,
      allTemplates,
      show;
    if (canvasEl) {
      // get instance of selected canvas el
      canvasElScope = get(canvasEl[0], 'widget');
    }

    const widgetType = !canvasElScope ? canvasEl?.attr('widgettype') : get(canvasElScope, 'widgetType');

    if (!canvasElScope && this.activeWidget) {
      this.activeWidget.name = canvasEl?.attr('name');
      this.activeWidget.widgetType = canvasEl?.attr('widgettype');
      this.activeWidget.widgetid = canvasEl?.attr('widget-id');
      this.activeMarkupEl = this.markupManager.getActiveMarkupEl();
      this.activeWidget.candelete = 'false';
      this.activeWidget.isDroppable = canvasEl?.attr("wm-droppable");
    } else if (!this.activeWidget || (canvasElScope && this.activeWidget.widgetId !== get(canvasElScope, 'widgetId'))) {
      this.activeWidget = canvasElScope;
      this.setActiveProperty({});
      this.activeMarkupEl = this.markupManager.getActiveMarkupEl();
      this.activeWidget.isDroppable = canvasEl?.attr("wm-droppable");
    }

    if (this.activeWidget.widgetType === 'wm-page') {
      this.activeWidget.pagetitle = this.activeMarkupEl?.attr('pagetitle');
    }

    if (widgetType === "wm-chart") {
      this.activeWidget.widgetProps['bubblesize'].show = this.activeWidget.widgetProps['shape'].show = (this.activeWidget.type === 'Bubble') ? true : false;
    }

    if (this.activeWidget.dynamicType) {
      this.activeWidget.widgetProps.addchild.show = false;
      this.activeWidget.widgetProps.dataset.show = true;
    }

    if (this.activeWidget['page-container'] || this.activeWidget.widgetType === 'wm-popover' || this.activeWidget.widgetType === 'wm-panel') {
      if (this.appRef.isApplicationType || this.appRef.isPrefabType) {
        /*if the selected widget is a pagecontainer, show the list of pages in the project*/
        let content = StudioUtils.getContentOptions(this.activeWidget.widgetType);
        if (this.activeWidget.widgetProps.content) {
          this.activeWidget.widgetProps.content.options = content.options;
          this.activeWidget.widgetProps.content.relevantOptions = content.relevantOptions;
        }
      } else {
        this.activeWidget.widgetProps.content.show = false;
      }
    }
    if (this.activeWidget.widgetType === 'wm-carousel') {
      if (!this.activeWidget.dynamicType) {
        this.activeWidget.widgetProps['nodatamessage'].show = false;
      }
    }

    // TODO: remove this check once the widgetProps refactoring is done

    if (this.activeWidget['margin'] === undefined) {
      this.activeWidget['margin'] = this.activeMarkupEl?.attr('margin')
    }
    if (this.activeWidget['padding'] === undefined) {
      this.activeWidget['padding'] = this.activeMarkupEl?.attr('padding')
    }
    if (this.activeWidget['borderwidth'] === undefined) {
      this.activeWidget['borderwidth'] = this.activeMarkupEl?.attr('borderwidth')
    }
    this.setShadowPropertiesAfterInit();

    // Added these on activeWidget as these properties are not existing on activeWidget (assigned from runtime)
    this.activeWidget.showindevice = this.activeMarkupEl?.attr('showindevice') || 'all';
    // if (this.activeWidget.widgetProps?.showindevice && !this.activeWidget.widgetProps.showindevice.options[0].name) {
    //   this.activeWidget.widgetProps.showindevice.options = PropertiesFactory.setShowInDeviceOptions();
    // }

    if (canvasEl?.attr('itemsperrow')) {
      this.activeWidget.itemsperrow = canvasEl?.attr('itemsperrow')
    }

    this.activeMarkupEl?.length && forEach(this.activeMarkupEl[0].attributes, (attr: Attr) => {
      if (startsWith(attr.name, 'on-')) {
        let eventName = attr.name.split('-');
        let exp = eventName[0].replace('on', '__on') + startCase(toLower(eventName[1]));
        set(this.activeWidget, exp, attr.value);
      }
    });
    if (this.activeWidget.widgetType === 'wm-chart') {
      // reset the multi select widgets inside property panel.
      // resetMultiSelectProperty();
    }

    // Removing not required caption property for toggle widget
    if (this.activeWidget.type === 'toggle') {
      this.activeWidget.widgetProps['caption'].show = false;
    }

    widgetProps = this.activeWidget.widgetProps;

    if (widgetProps) {
      //Reset the error flag on the widget properties
      forEach(widgetProps, (prop) => {
        if (prop.error) {
          prop.error = false;
        }
      });
      if (widgetProps.accessroles) {
        // TODO: implement PropertiesFactory.getRoles()
        /*get all the access roles & set them to the active widget accessroles property*/
        // widgetProps.accessroles.options = PropertiesFactory.getRoles();
      }

    }

    this.pageWs.showCreateNewPage = false;
    switch (this.activeWidget.widgetType) {
      case "wm-spinner":
        /*if the selected widget is a spinner, show the list of service-variables in the project*/
        this.activeWidget.widgetDataset = {};
        //get page,app variables for the spinner widget Track variable property
        let variableNames: any[] = [];
        this.activeWidget.widgetDataset.servicevariabletotrack = variableNames;
        forEach(getByContext([this.pageService.getActivePageName(), VARIABLE_CONSTANTS.OWNER.APP]), (variables, context) => {
          forEach(variables, (variable, name) => {
            if (isSpinnerType(variable.category)) {
              variableNames.push(name);
            }
          });
        });
        break;
      case "wm-search":
      case "wm-checkboxset":
      case "wm-radioset":
        if (!this.isTemplateBundleType) {
          this.pageWs.showCreateNewPage = true;
        }
        break;
      case "wm-form-field":
      case "wm-filter-field":
        if (!this.isTemplateBundleType && (this.activeWidget.widget === 'checkboxset' || this.activeWidget.widget === 'radioset' || this.activeWidget.widget === 'search')) {
          this.pageWs.showCreateNewPage = true;
        }
        break;
      case "wm-chart":
        this.updateMultiSelectProperty();
        if (this.activeWidget.type === 'Pie' || this.activeWidget.type === 'Donut') {
          PropertiesFactory.getPropertyGroup('xaxis').displayKey = 'LABEL_PROPERTY_LABEL_DATA';
          PropertiesFactory.getPropertyGroup('yaxis').displayKey = 'LABEL_PROPERTY_VALUE_DATA';
        } else {
          delete PropertiesFactory.getPropertyGroup('xaxis').displayKey;
          delete PropertiesFactory.getPropertyGroup('yaxis').displayKey;
        }
        break;
    }

    // if (this.activeWidget.hasOwnProperty('page-container') || this.activeWidget.widgettype === 'wm-popover') {
    //   if (this.pageWs.$root.isApplicationType || this.pageWs.$root.isPrefabType) {
    //     /*if the selected widget is a pagecontainer, show the list of pages in the project*/
    //     var content = StudioUtils.getContentOptions(this.activeWidget.widgettype);
    //     widgetProps.content.options = content.options;
    //     widgetProps.content.relevantOptions = content.relevantOptions;
    //   } else {
    //     widgetProps.content.show = false;
    //   }
    // }
    //
    // if (this.activeWidget.widgettype === 'wm-template') {
    //   allTemplates = ProjectService.getPageNames();
    //   ['header', 'topnav', 'leftnav', 'rightnav', 'footer'].forEach(function (key) {
    //     widgetProps[key].options = allTemplates;
    //   });
    // }

    this.showHideSubGroups();
    let isTemplateBundled: any = this.activeWidget.$element && this.activeWidget.$element.attr('is-template-bundled');
    let isLayoutBundled: any = this.activeWidget.$element && this.activeWidget.$element.attr('is-layout-bundled');
    // $rootScope.$emit('wms:load-widget-template', isTemplateBundled, isLayoutBundled, this.activeWidget.widgettype);
    runtimeEventManager.emit('load-widget-template', {
      isTemplateBundled, isLayoutBundled, widgetType: this.activeWidget.widgetType
    });
    this.updatePropertyPanelOptions(this.activeWidget);

    let name = this.activeWidget.name;
    if (this.activeWidget.pageName && !name) {
      this.activeWidget.name = this.activeWidget.nativeElement.getAttribute('name');
      this.activeWidget.widgetType = this.activeWidget.nativeElement.getAttribute('widgettype');
    }
    this.pageWs.activeWidget = this.activeWidget;
    // Conditionally calling clickHandler as it was causing duplicate click from canvas
    if(!disableCanvasDomServiceClick) {
      this.canvasDomService.clickHandler(undefined, this.activeWidget.widgetId);
    }
  }

  updatePropertyPanelOptions(activeWidget: any) {
    let keys: any,
      filtered: any,
      bindExpr,
      typeUtils,
      options: any,
      fieldObjects,
      ALLFIELDS = 'All Fields',
      checkboxsetTypeWidgets = ['multi-select', 'select-all', 'list-typeahead', 'order-by'],
      dataSetProp = includes(['wm-panel', 'wm-card'], activeWidget.widgetType) ? 'actions' : 'dataset',
      requiredProps: any = {},
      resetProps: any = {};

    bindExpr = activeWidget['bind' + dataSetProp];
    fieldObjects = this.typeFactoryService.getFieldsForExpr(bindExpr, { 'getFieldInfo': true });
    keys = {
      'objects': map(filter(fieldObjects, { 'type': 'object' }), 'field'),
      'terminals': map(filter(fieldObjects, { 'type': 'terminal' }), 'field')
    }
    keys.all = union(keys.objects, keys.terminals);
    forEach(activeWidget.widgetProps, (prop, name) => {
      if (prop.datasetfilter || prop.bindonly == 'expression') {
        requiredProps[name] = prop;
        resetProps[name] = (name == 'datafield' && prop.allfields) ? ALLFIELDS : '';
        if (name === 'displayexpression') {
          resetProps['bind' + name] = '';
        }
      }
    });

    if (activeWidget.newcolumns) {
      activeWidget.newcolumns = false;
      forEach(resetProps, (prop, name) =>{
        activeWidget[name] = prop;
      });
      runtimeEventManager.emit('set-markup-attr', {widgetId: activeWidget.widgetId, ...resetProps})
    }
    forEach(requiredProps, async (prop, name) => {
      filtered = prop.datasetfilter;
      if (filtered && filtered !== 'none') {
        if (isEmpty(keys)) {
          options = []
        } else {
          switch (filtered) {
            case 'all':
              options = keys.all;
              break;
            case 'objects':
              options = keys.objects;
              break;
            case 'terminals':
              options = keys.terminals;
              break;
            case 'custom':
              //Widgets like chart need filtering of options
              if (this.activeWidget && isFunction(this.activeWidget.getCustomizedOptions)){
                options = await this.activeWidget.getCustomizedOptions(name, keys.terminals);
              }
              break;
          }
        }
        if (prop.allfields) {
          options = [ALLFIELDS].concat(options);
        }
        if (!includes(checkboxsetTypeWidgets, prop.widget)) {
          options = [''].concat(options);
        }
        this.updateOptions(name, prop, options, activeWidget || this.activeWidget);
      }
    })
  }

  updateOptions(name: string, prop: any, options: [], activeWidget: any) {
    if (prop.widget === 'multi-select') {
      activeWidget.widgetDataset = activeWidget.widgetDataset || {};
      activeWidget.widgetDataset[name] = options;
    }
    else if (prop.widget == 'list-typeahead') {
      let optionObjects = [],
        defaultOptions: any = [],
        optionCategoryName = 'Field';
      if (includes(['wm-list', 'wm-form-field', 'wm-filter-field'], activeWidget?.widgetType) || name === 'groupby') {
        defaultOptions = [{ "name": "Javascript", "category": "Script" }];
        if (activeWidget && includes(activeWidget[prop], '(')) {
          defaultOptions.push({
            'category': 'Script',
            'name': activeWidget[prop]
          });
        }
      }
      optionObjects = defaultOptions;
      options.forEach((option: any) => {
        optionObjects.push({
          'category': optionCategoryName,
          'name': option
        });
      });
      prop.options = optionObjects;
    } else {
      prop.options = options;
    }
  }

  // TODO: check when this gets called
  setActiveProperty(property: any) {
    this.activeProperty = property;
  };

  setShadowProperties(properties: Map<string, Property>) {
    this.propPanel.shadowProperties = {};
    forEach(properties, (key: any, property: string) => {
      /*if the property is bindable, update the property value to the "bind"+property value in shadow properties to display the variable name in the property panel property*/
      if (this.activeWidget.widgetProps[property]?.bindable && this.activeWidget["bind" + property] && this.activeWidget["bind" + property] !== "") {
        set(this.propPanel.shadowProperties, property, this.activeWidget["bind" + property]);
      } else {/*else update the same property in shadowProperties*/
        /*For properties such as "scopedataset", the value will be available in the activeWidget only in the run mode.
        * Hence fetch the value from the activeMarkupEl and set it in shadow properties.*/
        if(property === 'xaxisdatakey'){
          set(this.propPanel.shadowProperties, property, this.activeWidget.xaxisdatakey)
        }

        if (property === "scopedataset") {
          set(this.propPanel.shadowProperties, property, this.activeMarkupEl?.attr(property));
        } else if (property === 'widget') {
          set(this.propPanel.shadowProperties, property, this.activeWidget.displaywidget);
        } else {
          set(this.propPanel.shadowProperties, property, this.activeWidget[property]);
        }

      }
    });
  };

  // returns 'true' if at least one property of the given subgroup is to be shown, else false.
  showHideSubGroups() {
    let aw = this.activeWidget,
        widgetName = this.activeWidget.widgetSubType === 'wm-form-field-custom-widget' ? this.activeWidget.formWidget.nativeElement.widget.widgetName : this.activeWidget.widgetName,
        wp = aw && aw.widgetProps;

    forEach(this.propPanel?.propertyGroups, (group) => {
      forEach(group.subGroups, (subGroup) => {
        let flg = false;

        if (wp && subGroup.properties) {
          if (aw.prefabName) {
            if (isDefined(subGroup.boundPrefabName)) {
              flg = this.activeWidget.prefabName === subGroup.boundPrefabName;
            } else {
              if (subGroup.parent === 'properties') {
                flg = !subGroup.name;
              } else if (subGroup.parent === 'events') {
                flg = includes(this.prefabManager.prefabSkipEventSubGroups, subGroup.name) && !subGroup.boundComponentName;
              } else {
                flg = this.hasProperty(subGroup, wp);
              }
            }
            if (!subGroup.filteredProps) {
              this.propPanel.filterProperties(group)
            }
          } else if (aw.componentName) {
            if (isDefined(subGroup.boundComponentName)) {
              flg = this.activeWidget.componentName === subGroup.boundComponentName;
            } else {
              if (subGroup.parent === 'properties') {
                flg = !subGroup.name;
              }
              else if (subGroup.parent === 'events') {
                flg = includes(this.prefabManager.prefabSkipEventSubGroups, subGroup.name) && !subGroup.boundPrefabName;
              }
              else {
                flg = this.hasProperty(subGroup, wp);
              }
            }
            if (!subGroup.filteredProps) {
              this.propPanel.filterProperties(group)
            }
          }
          else if (widgetName) {
            if (isDefined(subGroup.boundWidgetName)) {
              if (subGroup.parent === 'events') {
                flg = !this.hasProperty(subGroup, wp);
              }
              else {
              flg = widgetName === subGroup.boundWidgetName;
              }
            }
            else {
                flg = this.hasProperty(subGroup, wp);
            }
            if (!subGroup.filteredProps) {
              this.propPanel.filterProperties(group)
            }
          }
          else {
            flg = !subGroup.boundPrefabName && !subGroup.boundComponentName && !subGroup.boundWidgetName && this.hasProperty(subGroup, wp);
          }
        }

        subGroup.show = flg;
      });
    });
  }

  // TODO: set the params with proper typing
  hasProperty(subGroup: any, wp: any) {
    // Check for the properties inside the subgroup that have show property as true.
    return some(subGroup.properties, (propName: string) => {
      return wp[propName] && wp[propName].show && !wp[propName].showindesigner;
    });

  }

  override ngOnDestroy() {
    super.ngOnDestroy();
    this.$$canvas?.off('mousedown selectstart');
    window.removeEventListener('closeChatWindow', this.hideAgenticChat.bind(this));
  }

  hideAgenticChat() {
    this.showAgenticChat = false;
  }

  private updateMultiSelectProperty() {
    let aw = this.activeWidget,
      wp = aw.widgetProps,
      propType = 'multi-select';

    wp.groupby.widget = 'multi-select';
    /*If chart type is pie or donut the yaxisdatakey and groupby is list*/
    if (aw.type === 'Pie' || aw.type === 'Donut') {
      propType = 'list';
    }
    wp.yaxisdatakey.widget = propType;
    wp.groupby.widget = propType;
  }

  handleAdvancedSettingsClick = (propPanelData: any) => {
    let designerTypes = {
      'TABLE': 'TABLE',
      'LIVEFORM': 'LIVEFORM',
      'LIVEFILTER': 'LIVEFILTER',
      'FORM': 'FORM',
      'CHART': 'CHART'
    }
    let getDesignerType = (widgetType: any) => {
      switch (widgetType) {
        case 'wm-table': return designerTypes.TABLE;
        case 'wm-liveform': return designerTypes.LIVEFORM;
        case 'wm-livefilter': return designerTypes.LIVEFILTER;
        case 'wm-form': return designerTypes.FORM;
        case 'wm-chart': return designerTypes.CHART;
        default: return '';
      }
    }
    let designerType: string = getDesignerType(this.activeWidget?.widgetType);
    this.propPanelInfo = propPanelData;
    this.dialogService.open('DialogLiveWidgetsDesigner', {customClasses: designerType.toLowerCase() + '-designer-dialog ' + 'large wm-studio-dialog'})
  }

  isFormDesignerType() {
    if (this.activeWidget.widgetType === 'wm-liveform' || this.activeWidget.widgetType === 'wm-form') {
      return this.activeWidget.widgetType;
    }
  }
  openChangeLayoutDialog(){
    this.dropdownPageAction.isOpen = false
    this.dialogService.open('layoutOptions')
  }
  displayRename(pageName: string) {
    return !includes(this.CONSTANTS.EXCLUDED_PAGES_BY_FEATURE.RENAME, pageName)
  }

  displayDelete(pageName: string) {
    return !includes(this.CONSTANTS.EXCLUDED_PAGES_BY_FEATURE.DELETE, pageName);
  }

  editPageName(event: any,pageName: string,pageType: string) {
    this.dropdownPageAction.isOpen = false
    this.eventManager.emitOnEditPageName({pageName,pageType});

  }

  duplicatePage(event: any,pageName: string,pageType: string) {
    this.dropdownPageAction.isOpen = false
    this.eventManager.emitOnPageDuplicate({pageName,pageType});

  }

  deletePage(event: any,pageName: string,pageType: string) {
    this.dropdownPageAction.isOpen = false
    this.eventManager.emitOnDeletePage({pageName,pageType});

  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;

    if (this.dropdownPageAction?.isOpen && !target.closest('.dropdownPageAction') && !target.closest('.page-actions')) {
      this.dropdownPageAction.isOpen = false;
    }
  }

}
